import initializeIziButton from "./woocommerceizi/initializeIziButton";
import unboundWidgetClicked from "./woocommerceizi/unboundWidgetClicked";
import handleBasketEvent from "./woocommerceizi/handleBasketEvent";
import refreshIziButton from "./woocommerceizi/refreshIziButton";
import elementorRefreshIziButton from "./woocommerceizi/elementorRefreshIziButton";
import refreshSingleProductPage from "./woocommerceizi/refreshSingleProductPage";
import setupAnalytics from "./woocommerceizi/setupAnalytics";
import {inpostPayBinding} from "./woocommerceizi/inpostPayBinding";
import {autoClickIziButtonIfCurrencyRestored} from "./woocommerceizi/autoClickIziButtonIfCurrencyRestored";
import getCookie from "./woocommerceizi/helpers/getCookie";
import setCookie from "./woocommerceizi/helpers/setCookie";

(function () {

  const originalDispatch = EventTarget.prototype.dispatchEvent;

  EventTarget.prototype.dispatchEvent = function (event) {
    try {
      if (
        event &&
        event.type &&
        (
          event.type.includes('wc') ||
          event.type.includes('cart') ||
          event.type.includes('basket') ||
          event.type.includes('izi')
        )
      ) {
        // Ensure event.detail exists
        if (event.detail === undefined || event.detail === null) {
          event.detail = {data: {}};
        }
      }
    } catch (e) {
      console.warn('[InPostPay] DOM event safeguard error', e);
    }

    return originalDispatch.call(this, event);
  };

})();

if (typeof InpostIziJavsscriptWoocommerce === "object") {
  window.addEventListener("load", async function () {
    const basketIdFromCookie = getCookie('basket_binding_api_key');
    if (
      IPPWidgetOptions &&
      typeof basketIdFromCookie === "string" &&
      basketIdFromCookie.trim() !== "" &&
      basketIdFromCookie !== "undefined"
    ) {
      const basketBindingApiKey = basketIdFromCookie.trim();
      IPPWidgetOptions.basketBindingApiKey = basketBindingApiKey;
      setCookie('basket_binding_api_key', basketBindingApiKey, 3600 * 24)
    }

    window.IPPwidget = InPostPayWidget.init(IPPWidgetOptions);
    initializeIziButton();
    setupAnalytics();
    observeCountBadge();
    const currencyWasRestored = Boolean(
      window.InpostIziJavsscriptWoocommerce?.currency_restored,
    );
    autoClickIziButtonIfCurrencyRestored(currencyWasRestored);
  });

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      IPPWidgetOptions.unboundWidgetClicked = unboundWidgetClicked;
      IPPWidgetOptions.handleBasketEvent = handleBasketEvent;
      refreshIziButton();
      elementorRefreshIziButton();
      refreshSingleProductPage();
    },
    false,
  );
}

function observeCountBadge() {
  let lastBadgePresent = false;
  let shadowObserver = null;

  function handleBadgeChange() {
    const iziButton = document.querySelector("inpost-izi-button");
    if (iziButton && iziButton.shadowRoot) {
      const badge = iziButton.shadowRoot.querySelector(".count-badge");
      if (badge && !lastBadgePresent) {
        lastBadgePresent = true;
        inpostPayBinding();
      } else if (!badge && lastBadgePresent) {
        lastBadgePresent = false;
      }
    } else {
      lastBadgePresent = false;
    }
  }

  const domObserver = new MutationObserver(() => {
    const iziButton = document.querySelector("inpost-izi-button");
    if (iziButton && iziButton.shadowRoot) {
      if (!shadowObserver) {
        shadowObserver = new MutationObserver(handleBadgeChange);
        shadowObserver.observe(iziButton.shadowRoot, {
          childList: true,
          subtree: true,
        });
      }
      handleBadgeChange();
    } else {
      if (shadowObserver) {
        shadowObserver.disconnect();
        shadowObserver = null;
      }
      lastBadgePresent = false;
    }
  });

  domObserver.observe(document.body, {childList: true, subtree: true});

  setInterval(handleBadgeChange, 200);
}
